export function isValidDate(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);

  // Check basic format
  if (
    !dateString ||
    dateString.split("-").length !== 3 ||
    !year ||
    !month ||
    !day
  ) {
    return false;
  }

  // Get the maximum valid day for that month
  const daysInMonth = new Date(year, month, 0).getDate();

  return day >= 1 && day <= daysInMonth;
};